import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "scraperRunsTheme"

// Light by default; persisted preference when present.
export default class extends Controller {
  connect() {
    if (localStorage.getItem(STORAGE_KEY) === "dark") {
      this.element.classList.add("dark")
    } else {
      this.element.classList.remove("dark")
    }
  }

  toggle() {
    this.element.classList.toggle("dark")
    localStorage.setItem(
      STORAGE_KEY,
      this.element.classList.contains("dark") ? "dark" : "light"
    )
  }
}
